var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRedDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_59215)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16096 4.78596C2.41724 4.52968 2.83276 4.52968 3.08904 4.78596L7 8.69692L10.911 4.78596C11.1672 4.52968 11.5828 4.52968 11.839 4.78596C12.0953 5.04224 12.0953 5.45776 11.839 5.71404L7.46404 10.089C7.20776 10.3453 6.79224 10.3453 6.53596 10.089L2.16096 5.71404C1.90468 5.45776 1.90468 5.04224 2.16096 4.78596Z",
    fill: "#FF4D4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_59215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRedDown);
export default __webpack_public_path__ + "static/media/arrow-red-down.1bf7cb35.svg";
export { ForwardRef as ReactComponent };